module.exports = __webpack_public_path__ + "57908b61ed40a4bfb8afb0b899a96ae4.jpg";